import { render, staticRenderFns } from "./T1Przewodnik.vue?vue&type=template&id=19d5c105&scoped=true&"
import script from "./T1Przewodnik.vue?vue&type=script&lang=js&"
export * from "./T1Przewodnik.vue?vue&type=script&lang=js&"
import style0 from "./T1Przewodnik.vue?vue&type=style&index=0&id=19d5c105&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d5c105",
  null
  
)

export default component.exports